import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { EditCommunicationComponent } from '../edit-communication/edit-communication.component';
import { CommunicationService } from '../service/communication.service';

@Component({
  selector: 'app-delete-communication',
  templateUrl: './delete-communication.component.html',
  styleUrls: ['./delete-communication.component.scss']
})
export class DeleteCommunicationComponent implements OnInit {
  commId: number;
  frequencyId: number;
  airportId: number;
  isLoading = false;

  constructor(private _matDialogRef: MatDialogRef<EditCommunicationComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _commService: CommunicationService) {
    this.commId = data.commId;
    this.frequencyId = data.frequencyId;
    this.airportId = data.airportId;
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
  }

  close(data: any) {
    this._matDialogRef.close(data);
  }

  async delete() {
    try {
      this.isLoading = true;
      await this._commService.deleteFrequency(this.airportId, this.frequencyId);
      // if no other frequencies left on the comm, delete it too
      const flightComm = await this._commService.getComm(this.airportId, this.commId);
      if (flightComm.frequencies && flightComm.frequencies.length === 0) {
        await this._commService.deleteComm(this.airportId, this.commId);
      }
      this.isLoading = false;
      this.close({success: true, commId: this.commId});
    } catch (e) {
      this.close({success: false, error: e});
    }
  }

  cancel () {
    this.close({cancelBtnClicked: true});
  }
}
